import { gql } from '@apollo/client';

export type {
  RevokeApiKey as IRevokeApiKey,
  RevokeApiKeyVariables as IRevokeApiKeyVariables,
} from './__generated__/RevokeApiKey';

export const REVOKE_API_KEY = gql`
  mutation RevokeApiKey($token: String!) {
    deactivatePartnerAuthToken(authToken: $token)
  }
`;
